
import {
  apiWithdrawList,
  apiWithdrawConfig,
  apiWithdrawConfigSet,
  apiWithdrawStatusSet,
  apiWithdrawUpVoucher,
} from "@/api/shop";
import { Component, Prop, Vue } from "vue-property-decorator";
import lsPagination from "@/components/ls-pagination.vue";
import LsDialog from "@/components/ls-dialog.vue";
import { RequestPaging } from "@/utils/util";
import DatePicker from "@/components/date-picker.vue";
import config from "@/config";
import { apiShopLists } from "@/api/shop";
@Component({
  components: {
    lsPagination,
    LsDialog,
    DatePicker,
  },
})
export default class ShopList extends Vue {
  /** S Data **/

  apiWithdrawList = apiWithdrawList;

  pager: RequestPaging = new RequestPaging();

  searchObj = {
    status: '', sid: '', start_time: '', end_time: ''
  };
  statusList = []
  withdrawDialogVisible = false;
  shopList: any[] = [];
  rate = 0;
  apply_remark = "";
  withdraw_status = 2;
  transfer_voucher: any = [];
  transfer_remark = "";
  withdrawStatusDailogShow = false;
  withdrawUpVoucherDailogShow = false;
  detail = {};
  detailDialogVisible = false;
  withdrawStatusId = 0;
  version = config.version;
  action = `${config.baseURL}/platformapi/upload/image`;
  fileList: any[] = []
  time: any = []
  // 日期选择器配置
  pickerOptions = {
    shortcuts: [
      {
        text: "最近一周",
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "最近一个月",
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "最近三个月",
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          picker.$emit("pick", [start, end]);
        },
      },
    ],
  };
  /** E Data **/
  /** S Methods **/
  // 获取提现配置
  handleChange(file: any, fileList: any) {
    // 封装移除文件的方法
    const removeFileFromList = (fileList: any, file: any) => {
      const index = fileList.findIndex((f: any) => f.uid === file.uid);
      if (index !== -1) {
        fileList.splice(index, 1);
      }
    };
    this.fileList.push(file);
    this.transfer_voucher.push(URL.createObjectURL(file.raw));
  }
  changeDate() {
    if (this.time.length) {
      this.searchObj.start_time = this.time[0];
      this.searchObj.end_time = this.time[1];
    }
  }
  getRateConfig() {
    apiWithdrawConfig({}).then((res) => {
      this.rate = res.rate;
    });
  }
  showRate() {
    this.getRateConfig();
    this.withdrawDialogVisible = true;
  }
  setRate() {
    apiWithdrawConfigSet({
      value: this.rate,
    }).then(() => {
      this.withdrawDialogVisible = false;
    });
  }
  //
  getShopLists(): void {
    this.pager.request({
      callback: apiWithdrawList,
      params: {
        ...this.searchObj,
      },
    }).then((res) => {
    })
  }
  showDetail(value: any) {
    this.detail = value;
    this.detailDialogVisible = true;
  }

  handleWithdrawStatusShow(value: any) {
    this.detail = value;
    this.withdrawStatusDailogShow = true;
    this.withdrawStatusId = value.id;
  }
  resetWithdraw() {
    this.apply_remark = "";
    this.withdraw_status = 2;
  }
  handleUploadSuccess(value: any) {
    if (value.code == 1) {
      this.transfer_voucher = value.data.uri;
    }
  }
  // 提现状态
  async withdrawStatus() {
    if (this.withdraw_status == 4) {
      if (!this.apply_remark) {
        this.$message.error("请输入审核备注");
        return;
      }
      await this.$confirm("驳回提现，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      });
    } else if (this.withdraw_status == 2) {
      await this.$confirm("通过提现，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      });
    }
    apiWithdrawStatusSet({
      id: this.withdrawStatusId,
      status: this.withdraw_status,
      audit_remark: this.apply_remark,
    }).then(() => {
      this.getShopLists();
      this.withdrawStatusDailogShow = false;
    });
  }

  handleWithdrawUpVoucherShow(value: any) {
    this.detail = value;
    this.transfer_remark = value.transfer_remark;
    this.transfer_voucher = value.transfer_voucher;
    this.withdrawUpVoucherDailogShow = true;
    this.withdrawStatusId = value.id;
  }
  async uploadImage(file: any) {
    try {
      const formData = new FormData()
      formData.append('file', file.raw)
      let res: Response = await fetch(this.action, {
        method: 'POST',
        headers: {
          token: this.$store.getters.token,
          version: this.version,
        },
        body: formData
      })
      let result = await res.json()
      if (result.code == 1) {
        return result.data.uri
      } else {
        throw new Error(result.msg)
      }
    } catch (error: any) {
      this.$message.error(error.message)
    }
  }
  removeVoucher(index: number) {
    console.log(index)
    this.transfer_voucher.splice(index, 1)
  }
  // 上传凭证
  async withdrawUpVoucher() {
    let loading = this.$loading({
      lock: true,
      text: '上传中...',
      background: 'rgba(0, 0, 0, 0.7)',
    })
    const promises = []
    for (let item of this.fileList) {
      promises.push(this.uploadImage(item))
    }
    let transfer_voucher = await Promise.all(promises)
    this.fileList = []
    loading.close()
    apiWithdrawUpVoucher({
      id: this.withdrawStatusId,
      transfer_voucher: [...this.transfer_voucher.filter((item: any) => item.indexOf('blob') === -1), ...transfer_voucher],
      transfer_remark: this.transfer_remark,
    }).then(() => {
      this.getShopLists();
      this.withdrawUpVoucherDailogShow = false;
    });
  }
  // 重置搜索
  reset(): void {
    Object.keys(this.searchObj).map((key) => {
      this.$set(this.searchObj, key, "");
    });
    this.getShopLists();
  }
  async getShopList() {
    try {
      let res = await apiShopLists({ page_size: 9999 })
      this.shopList = res.lists;
    } catch (error) {

    }
  }
  /** E Methods **/

  /** S ods **/
  async created() {
    await this.getShopList()
    apiWithdrawList({}).then((res) => {
      this.statusList = res.extend
    })
    this.getShopLists();
  }
}
